import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, BehaviorSubject } from 'rxjs';
import { TranslateApiService } from './translate-api';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../services/core/auth.services';
import { environment } from '../../environments/environment';

@Injectable()
export class Globals {
  language: string;
  scrollEpisode: string;
  ctrlToken = 0;
  options = {
    closeButton: true,
    disableTimeOut: false,
    timeOut: 1000,
    extendedTimeOut: 500,
    enableHtml: false,
    progressBar: true,
    toastClass: 'ngx-toastr',
    positionClass: 'toast-top-right',
    titleClass: 'toast-title',
    messageClass: 'toast-message',
    easing: 'ease-in',
    easeTime: 100,
    tapToDismiss: true,
    onActivateTick: true,
    progressAnimation: 'increasing'
  };
  editMode = {
    open: 'open',
    authoryOnly: 'authory-only',
    restricted: 'restricted'
  };
  languageEnumerable = {
    es: 'es',
    en: 'en',
    spanish: 'spanish',
    english: 'english'
  };
  encounterEditMode = '';
  autoComplete = {
    basic: 'autoComplete.basic',
    newRegistry: 'autoComplete.newRegistry',
    info: 'autoComplete.info'
  };
  identificationCategory = {
    personal: 'personal_id',
    clinical: 'clinical_id',
    fiscal: 'fiscal_id',
    medicalRecord: 'medical_record'
  };

  messageTimer: any;
  sessionTimer: any;
  sessionTimeOut: any;
  messageTimeOut: any;
  randomTabId: any;
  loadRoles: any;
  roles: any;
  sessionDialogStatus = new BehaviorSubject(false);
  showSideBar = this.sessionDialogStatus.asObservable();
  globalSetings: any = {};

  constructor(
    public translate: TranslateService,
    public toastCtrl: ToastrService,
    private traslateText: TranslateApiService,
    public auth: AuthService
  ) {
    this.loadRoles = false;

    localStorage.setItem('open', new Date().getTime().toString());

    window.onstorage = event => {
      if (event.key === 'close') {
        this.resetSessionIntervals();
        this.auth.logout();
      }

      if (event.key === 'open') {
        this.setSessionTimer();
      }
    };

    this.messageTimeOut = 1000 * 60 * environment.sessionExpirationTime;
    this.sessionTimeOut = this.messageTimeOut + 180000;
    this.language = localStorage.getItem('lang');
    this.encounterEditMode = JSON.parse(localStorage.getItem('configTabs'));
    this.encounterEditMode = this.encounterEditMode && this.encounterEditMode['encounterEditMode'] ? this.encounterEditMode['encounterEditMode'] : '';
    this.globalSetings = JSON.parse(localStorage.getItem('GlobalSettings'));
  }

  setSessionTimer() {
    this.resetSessionIntervals();
    this.sessionDialogStatus.next(false);
    this.messageTimer = setTimeout(() => {
      this.sessionDialogStatus.next(true);
    }, this.messageTimeOut);

    this.sessionTimer = setTimeout(() => {
      this.sessionDialogStatus.next(false);
      this.resetSessionIntervals();
      this.auth.logout();
    }, this.sessionTimeOut);
  }

  resetSessionIntervals() {
    this.sessionDialogStatus.next(false);
    clearInterval(this.messageTimer);
    clearInterval(this.sessionTimer);
  }

  errorMessage(error) {
    const sn = typeof error === 'string' ? undefined : error.error.errors;
    let message = '';
    if (typeof error === 'string') {
      message = error;
      this.error(message);
    } else if (
      error.message &&
      error.message
        .toString()
        .toLowerCase()
        .includes('http failure response for')
    ) {
      // This fortmat is for service down
      message = 'Error de conexión por favor intente mas tarde';
      this.error(message);
    } else if (error.error && error.error.code) {
      this.error(error.error.code);
    } else if (sn === undefined) {
      // This format is for field duplicate
      message = error.error.message;
      this.error(message);
    } else if (sn.stack && sn.stack.code) {
      // This format is for maximum allowed length
      message = sn.stack.code.message;
      this.error(message);
    } else if (sn.message === undefined) {
      // This format is for field required
      Object.keys(sn).forEach(key => {
        this.error(sn[key].message);
        // this.toastCtrl.error(sn[key].message);
      });
    } else if (sn.message) {
      // This format is for login errors
      message = sn.message;
      this.error(message);
    }
  }

  successMessage(): Observable<any> {
    if (this.language === 'es') {
      return this.toastCtrl.success('', '¡Operación exitosa!', {
        closeButton: true,
        disableTimeOut: false,
        timeOut: 2000,
        extendedTimeOut: 500,
        progressBar: true,
        easing: 'ease-in',
        easeTime: 100,
        tapToDismiss: true,
        progressAnimation: 'increasing'
      }).onHidden;
    } else {
      return this.toastCtrl.success('', 'Successfull!', {
        closeButton: true,
        disableTimeOut: false,
        timeOut: 2000,
        extendedTimeOut: 500,
        progressBar: true,
        easing: 'ease-in',
        easeTime: 100,
        tapToDismiss: true,
        progressAnimation: 'increasing'
      }).onHidden;
    }
  }

  success(message) {
    this.toastCtrl.success('', message, {
      closeButton: true,
      disableTimeOut: false,
      timeOut: 2000,
      extendedTimeOut: 500,
      progressBar: true,
      easing: 'ease-in',
      easeTime: 100,
      tapToDismiss: true,
      progressAnimation: 'increasing'
    }).onHidden;
  }

  guestMessage(message) {
    this.toastCtrl.success(message);
  }

  error(message) {
    this.translate.get('errors.' + message).subscribe(text => {
      if (text.startsWith('errors.')) {
        this.toastCtrl.error('', message, {
          closeButton: true,
          disableTimeOut: false,
          timeOut: 2000,
          extendedTimeOut: 500,
          progressBar: true,
          easing: 'ease-in',
          easeTime: 100,
          tapToDismiss: true,
          progressAnimation: 'increasing'
        }).onHidden;
      } else {
        this.toastCtrl.error('', text, {
          closeButton: true,
          disableTimeOut: false,
          timeOut: 2000,
          extendedTimeOut: 500,
          progressBar: true,
          easing: 'ease-in',
          easeTime: 100,
          tapToDismiss: true,
          progressAnimation: 'increasing'
        }).onHidden;
      }
    });
  }

  warn(message) {
    this.translate.get('warns.' + message).subscribe(text => {
      this.toastCtrl.warning(text);
    });
  }

  directWarningMessage(message) {
    this.toastCtrl.warning(message);
  }

  throwServerError() {
    this.translate.get('errors.serverError').subscribe(text => {
      this.toastCtrl.error(text);
    });
  }

  translateContent(message) {
    return this.traslateText.traslateEnToEs(message, this.translate.currentLang);
  }

  scrollTo(value) {
    this.scrollEpisode = value;
  }
  getScrollTo() {
    return this.scrollEpisode;
  }

  tokenExpired(msg: String) {
    this.ctrlToken++;
    if (this.ctrlToken === 1) {
      this.error(msg);
    }
  }

  practtionerID() {
    const decoded = jwtDecode<{ practitioner: string }>(JSON.parse(localStorage.getItem('user')).token);
    return decoded.practitioner;
  }
  getEditionEnumerables(practitionerValidator) {
    const config = {
      open: false,
      restricted: false,
      authoryOnly: false,
      restrictedOrAuthoryOnly: false
    };
    if (this.encounterEditMode === this.editMode.open) {
      config.open = true;
    } else if (this.encounterEditMode === this.editMode.restricted) {
      config.restricted = true;
    } else if (this.encounterEditMode === this.editMode.authoryOnly && practitionerValidator) {
      config.authoryOnly = true;
    }
    return config;
  }
  isBlock(printed) {
    if (this.encounterEditMode === this.editMode.restricted && printed) {
      return true;
    } else {
      return false;
    }
  }
  getLangugeEnumerableMin(languages) {
    if (this.translate.currentLang === this.languageEnumerable.es) {
      const lang = languages.find(
        langElement => langElement.text === this.languageEnumerable.spanish || langElement.text === this.languageEnumerable.es
      );
      return lang;
    } else if (this.translate.currentLang === this.languageEnumerable.en) {
      const lang = languages.find(
        langElement => langElement.text === this.languageEnumerable.english || langElement.text === this.languageEnumerable.en
      );
      return lang;
    }
  }

  translateTextToShow(name: string) {
    this.translate.get(name).subscribe(text => {
      return (name = text);
    });
    return name;
  }

  setGroup(array, text, attribute?) {
    this.translate.get(this.autoComplete[text]).subscribe(textResponse => {
      array.forEach(elementArray => {
        return (elementArray[attribute ? attribute : 'group'] = textResponse);
      });
      return array;
    });
    return array;
  }

  customMessage(text: string, type: 'error' | 'success') {
    const options: any = {
      closeButton: true,
      disableTimeOut: false,
      timeOut: 5000,
      extendedTimeOut: 500,
      progressBar: true,
      easing: 'ease-in',
      easeTime: 100,
      tapToDismiss: true,
      progressAnimation: 'increasing'
    };

    if (type === 'error') {
      this.toastCtrl.error('', text, options).onHidden;
    }

    if (type === 'success') {
      this.toastCtrl.success('', text, options).onHidden;
    }
  }
}
